var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTetrapak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 4,
    fill: "#E0F6F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3378 15.5927L15.5121 18.4184M18.3378 15.5927H25.6621M18.3378 15.5927V13.4494H25.6621V15.5927M15.5121 18.4184V30.5506H24.0461M15.5121 18.4184H21.0213M25.6621 15.5927L28.4878 18.4184V30.5506H24.0461M25.6621 15.5927L24.0461 18.4184V30.5506",
    stroke: "url(#paint0_linear_1781_6627)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1781_6627",
    x1: 33.6578,
    y1: 12.0466,
    x2: 10.308,
    y2: 25.0856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0083CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FB073"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTetrapak);
export default __webpack_public_path__ + "static/media/tetrapak.5701d621415780ab2c14471546c0deb6.svg";
export { ForwardRef as ReactComponent };